// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import AdminLayout from "./layouts/AdminLayout";
import BannerLayout from "./layouts/BannerLayout";

const App = () => {
  // 로그인 여부 확인 (글로벌)
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(() => {
    const isLoggedIn = window.sessionStorage.getItem("login");
    console.log(isLoggedIn === "loggin");
    setIsAuthenticated(isLoggedIn === "loggin");
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/*"
          element={isAuthenticated ? <AdminLayout /> : <Navigate to="/login" />}
        >
          <Route path="banners" element={<BannerLayout />} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;
